var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintain"},[_c('div',{staticClass:"maintain_content"},[_c('h1',[_vm._v("维护公告")]),_c('p',[_vm._v(" 亲爱的爱设计企业用户: 爱设计企业版将于5月18日晚上22:00-6:00点进行系统升级维护，预计持续8个小时，期间将无法登录使用爱设计企业版PC端和微信小程序企业版。 维护完成后，即可进行登录使用，给您带来的不便，敬请谅解！ ")])])])
}]

export { render, staticRenderFns }